import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import styles from './Sidebar.module.css';

const NAV_ITEMS = [
  { to: '/', label: '대시보드' },
  { to: '/branches', label: '지점 관리' },
  { to: '/comparison', label: '성과 비교' },
  { to: '/settings/franchise', label: '프랜차이즈 설정' },
  { to: '/settings/account', label: '계정 설정' },
  { to: '/inquiry', label: '문의/건의' },
];

export default function Sidebar() {
  const { franchiseName, logout } = useAuth();

  return (
    <aside className={styles.sidebar}>
      <div className={styles.logo}>
        <div className={styles.logoTitle}>{franchiseName || '만석'}</div>
        <div className={styles.logoSubtitle}>Franchise</div>
      </div>
      <nav className={styles.nav}>
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `${styles.navLink} ${isActive ? styles.navLinkActive : ''}`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className={styles.footer}>
        <button className={styles.logoutBtn} onClick={logout}>
          로그아웃
        </button>
      </div>
    </aside>
  );
}
